import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 10 19" {...props}>
      <title>{props.title || 'Carousel-Arrow-Right'}</title>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-473.000000, -123.000000)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          transform="translate(16.000000, 124.000000)"
          stroke="#FFFFFF"
          strokeWidth="3"
        >
          <polyline
            transform="translate(462.000000, 8.500000) scale(-1, 1) translate(-462.000000, -8.500000) "
            points="466 0.5 458 8.5 466 16.5"
          />
        </g>
      </g>
    </Icon>
  )
}
